import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { SEOMarketingPage } from './SEOMarketingPage'
import { ConversionLabelsPage } from './ConversionLabelsPage'
import { useSettingsTab } from './useSettingsTab'

export function SEOAttributionPage() {
  const [tab, setTab] = useSettingsTab('seo')

  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList>
        <TabsTrigger value="seo">SEO & Marketing</TabsTrigger>
        <TabsTrigger value="conversion-labels">Conversion Labels</TabsTrigger>
      </TabsList>

      <TabsContent value="seo">
        <SEOMarketingPage />
      </TabsContent>

      <TabsContent value="conversion-labels">
        <ConversionLabelsPage />
      </TabsContent>
    </Tabs>
  )
}
